import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./Keycloak";
import { RouterProvider } from "react-router-dom";
import PostHogProviderWrapper from "./providers/PostHogProviderWrapper";
import { toast } from "sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LuTriangleAlert } from "react-icons/lu";
import ToastContent from "./components/common/toast/ToastContent";
import { router } from "./router";
import posthog from "posthog-js";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Enable logs to be sent to Sentry
  enableLogs: true,
  enabled: import.meta.env.VITE_APP_SCENARIO !== "dev",
  environment: import.meta.env.VITE_APP_SCENARIO as string,
});

const eventLogger = (event: unknown, error: unknown) => {
  console.log("onKeycloakEvent", event, error);
  if (event === "onAuthRefreshError") {
    posthog.reset();
    toast.message(
      <ToastContent
        icon={LuTriangleAlert}
        headingPrefix="Your session expired"
        subheadingSuffix="Your session expired. Please log in again."
        isError={true}
      />,
    );
  }
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    {/* {location.hostname === "localhost" && <ReactQueryDevtools initialIsOpen={false} />} */}
    <ReactQueryDevtools />
    <ReactKeycloakProvider
      initOptions={{ onLoad: "login-required" }}
      authClient={keycloak}
      onEvent={eventLogger}
    >
      <PostHogProviderWrapper>
        <RouterProvider router={router} />
      </PostHogProviderWrapper>
    </ReactKeycloakProvider>
  </QueryClientProvider>,
);
